import type { QueryClient } from '@tanstack/react-query';
import { campaignKeys } from './queryKeys';

// Invalidates every cache a *landed* campaign field change must refresh —
// detail, edit-request queries, and the roster/creator-content keys the
// per-creator product surfaces (e.g. ProductAssignCell) read from.
export function invalidateLandedCampaignFieldChange(queryClient: QueryClient, campaignId: string): void {
  queryClient.invalidateQueries({ queryKey: campaignKeys.detail(campaignId) });
  queryClient.invalidateQueries({ queryKey: campaignKeys.editRequestCurrent(campaignId) });
  queryClient.invalidateQueries({ queryKey: campaignKeys.editRequestHistory(campaignId) });
  queryClient.invalidateQueries({ queryKey: campaignKeys.rosterAll(campaignId) });
  queryClient.invalidateQueries({ queryKey: campaignKeys.creatorContentReports(campaignId) });
}
